<template>
    <div class="devices">
        <img src="../assets/404.png" alt="404(Not Found)">
        <h1>404</h1>
        <p>No Data Found</p>
    </div>
</template>

<script>
  
  export default {
    name: 'NotFound',
    components: {
    },
    data: () => ({
    }),

    methods: {
    },
  }
</script>
<style scoped>
.devices {
  margin-top:8%;
  margin-bottom: 2%;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  width:85%;
}
@media (max-width: 1000px) {
  .devices {
    margin-top: 10%;
  }
}
@media (max-width: 550px) {
  .devices {
    margin-top: 18%;
  }
}
</style>